export default {
	logout: 'logout'
}